<template>
  <div class="service-order-upsert">
    <KTCodePreview v-bind:title="title">
      <template v-slot:preview>
        <div class="text-center text-muted py-10">
          <i class="fas fa-tools" style="font-size: 2rem"></i>
          <p class="mt-3 mb-0">
            Màn tạo/sửa Phiếu dịch vụ — đang xây dựng (Phase 1+).
          </p>
        </div>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';

export default {
  name: 'ServiceOrderUpsert',
  components: { KTCodePreview },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  computed: {
    isEdit() {
      return !!this.id;
    },
    title() {
      return this.isEdit ? 'Sửa Phiếu dịch vụ' : 'Tạo Phiếu dịch vụ';
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Phiếu dịch vụ', route: '/service-orders' },
      { title: this.title },
    ]);
  },
};
</script>
